import { createSlice } from "@reduxjs/toolkit";

const webSocketSlice = createSlice({
  name: "webSocket",
  initialState: {
    isConnected: false,
  },
  reducers: {
    setWsConnected(state, action) {
      state.isConnected = action.payload; // true | false
    },
  },
});

export const { setWsConnected } = webSocketSlice.actions;
export default webSocketSlice.reducer;
